import React from "react";

const Loader = () => {
	return (
		<div className="d-flex align-items-center justify-content-center">
			<span className="btn-loader-red"></span>
		</div>
	);
};

export default Loader;
